import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "../lib/api";
import SEO from "../lib/SEO";

export default function BlogDetail() {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        setNotFound(false);
        setPost(null);
        api.get(`/blogs/${slug}`)
            .then((r) => setPost(r.data))
            .catch(() => setNotFound(true));
    }, [slug]);

    if (notFound) {
        return (
            <main className="pt-32 pb-20 max-w-3xl mx-auto px-4 text-center">
                <h2 className="font-display text-3xl mb-4">Article not found</h2>
                <Link to="/blog" className="btn-pink">Back to blog</Link>
            </main>
        );
    }

    if (!post) return <main className="pt-32 pb-20 text-center text-ink-soft">Loading…</main>;

    return (
        <main className="bg-[#FFF7FB]" data-testid="blog-detail-page">
            <SEO
                title={`${post.title} — Cake Central`}
                description={post.excerpt}
                image={post.image_url}
                path={`/blog/${post.slug}`}
                jsonLd={{
                    "@context": "https://schema.org",
                    "@type": "BlogPosting",
                    headline: post.title,
                    image: post.image_url,
                    datePublished: post.created_at,
                    author: { "@type": "Organization", name: post.author },
                }}
            />

            <article className="pt-24 md:pt-28">
                <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                    <Link to="/blog" className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-ink-soft hover:text-blush mb-8">
                        <ArrowLeft size={14} /> All articles
                    </Link>
                    <p className="text-[10px] tracking-[0.3em] uppercase text-ink-soft mb-3">
                        {new Date(post.created_at).toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" })}
                    </p>
                    <h1 className="font-display text-3xl md:text-5xl text-ink leading-tight mb-6" data-testid="blog-title">{post.title}</h1>
                    <p className="text-lg text-ink-soft leading-relaxed mb-10">{post.excerpt}</p>
                </div>

                <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
                    <div className="aspect-[16/9] overflow-hidden">
                        <img src={post.image_url} alt={post.title} className="w-full h-full object-cover" />
                    </div>
                </div>

                <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
                    <div className="prose prose-stone max-w-none text-ink-soft leading-relaxed whitespace-pre-line">
                        {post.content}
                    </div>
                </div>
            </article>
        </main>
    );
}
